import _ from 'lodash';
import { ReportedItem } from '../components/ContentOverview';

export const sortContentByOccurrence = (data: ReportedItem[]) => {
  const sortedData = [...data];
  const activityIdCounts = _.groupBy(data, 'activityId');
  sortedData.sort((a, b) => {
    const countDiff =
      activityIdCounts[b.activityId].length -
      activityIdCounts[a.activityId].length;
    if (countDiff !== 0) {
      return countDiff;
    }
    return Date.parse(a.createdAt) - Date.parse(b.createdAt);
  });
  return sortedData;
};
